module.exports = __webpack_public_path__ + "fonts/Latinka-MediumItalic.f16283a5.ttf";